export type AestheticsDemoPersona = {
  id: string;
  label: string;
  frontImageUrl: string;
  frontFileName: string;
  profileImageUrl: string;
  profileFileName: string;
  profileSide: "left" | "right";
};

export type WellnessDemoPersona = {
  id: string;
  label: string;
  wellnessImageUrl: string;
  wellnessFileName: string;
};

export const AESTHETICS_DEMO_PERSONAS: AestheticsDemoPersona[] = [
  {
    id: "hannah",
    label: "Hannah",
    frontImageUrl: "/demo/demo-hannah.jpeg",
    frontFileName: "demo-hannah.jpeg",
    profileImageUrl: "/demo/demo-hannah-profile.jpg",
    profileFileName: "demo-hannah-profile.jpg",
    profileSide: "right",
  },
  {
    id: "adriana",
    label: "Adriana",
    frontImageUrl: "/demo/demo-adriana.jpg",
    frontFileName: "demo-adriana.jpg",
    profileImageUrl: "/demo/demo-adriana-profile.jpg",
    profileFileName: "demo-adriana-profile.jpg",
    profileSide: "right",
  },
  {
    id: "laura",
    label: "Laura",
    frontImageUrl: "/demo/demo-laura-front-before.png",
    frontFileName: "demo-laura-front-before.png",
    profileImageUrl: "/demo/demo-laura-profile-before.png",
    profileFileName: "demo-laura-profile-before.png",
    profileSide: "right",
  },
  {
    id: "stephanie",
    label: "Stephanie",
    frontImageUrl: "/demo/demo-stephanie-front-before.png",
    frontFileName: "demo-stephanie-front-before.png",
    profileImageUrl: "/demo/demo-stephanie-profile-before.png",
    profileFileName: "demo-stephanie-profile-before.png",
    profileSide: "right",
  },
  {
    id: "mary",
    label: "Mary",
    frontImageUrl: "/demo/demo-mary-front-before.png",
    frontFileName: "demo-mary-front-before.png",
    profileImageUrl: "/demo/demo-mary-profile-before.png",
    profileFileName: "demo-mary-profile-before.png",
    profileSide: "right",
  },
  {
    id: "sandra",
    label: "Sandra",
    frontImageUrl: "/demo/demo-sandra-front-before.png",
    frontFileName: "demo-sandra-front-before.png",
    profileImageUrl: "/demo/demo-sandra-profile-before.png",
    profileFileName: "demo-sandra-profile-before.png",
    profileSide: "right",
  },
];

export type LashBrowDemoPersona = {
  id: string;
  label: string;
  frontImageUrl: string;
  frontFileName: string;
};

export const LASH_BROW_DEMO_PERSONAS: LashBrowDemoPersona[] = [
  {
    id: "mila",
    label: "Mila",
    frontImageUrl: "/demo/demo-lashbrow-mila.webp",
    frontFileName: "demo-lashbrow-mila.webp",
  },
  {
    id: "claire",
    label: "Claire",
    frontImageUrl: "/demo/demo-lashbrow-claire.webp",
    frontFileName: "demo-lashbrow-claire.webp",
  },
  {
    id: "renee",
    label: "Renee",
    frontImageUrl: "/demo/demo-lashbrow-renee.webp",
    frontFileName: "demo-lashbrow-renee.webp",
  },
];

export const WELLNESS_DEMO_PERSONAS: WellnessDemoPersona[] = [
  {
    id: "mike",
    label: "Mike",
    wellnessImageUrl: "/demo/demo-mike-wellness.jpg",
    wellnessFileName: "demo-mike-wellness.jpg",
  },
  {
    id: "phil",
    label: "Phil",
    wellnessImageUrl: "/demo/demo-phil-wellness.jpg",
    wellnessFileName: "demo-phil-wellness.jpg",
  },
  {
    id: "ruby",
    label: "Ruby",
    wellnessImageUrl: "/demo/demo-ruby-wellness.jpg",
    wellnessFileName: "demo-ruby-wellness.jpg",
  },
  {
    id: "tommy",
    label: "Tommy",
    wellnessImageUrl: "/demo/demo-tommy-wellness.webp",
    wellnessFileName: "demo-tommy-wellness.webp",
  },
];

export async function fetchDemoImageAsFile(imageUrl: string, fileName: string): Promise<File> {
  const res = await fetch(imageUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: blob.type || "image/jpeg" });
}
